module.exports = __webpack_public_path__ + "static/img/banner_01.af96c74a.png";